export const UI_COPY = {
    advancedToggle: {
        show: 'Show advanced ▼',
        hide: 'Hide advanced ▲'
    },
    alerts: {
        noSettingsLoaded: 'No mosaic settings loaded yet. Generate a mosaic or open one from Recent Mosaics first.',
        uploadTargetFirst: 'Please upload a target photo first!',
        selectLibraryFirst: 'Please select a Library first!',
        forkFailed: '⚠️ Error: Could not create new job context. Please try reloading the page.',
        selectOrCreateLibrary: 'Select or Create a library first!'
    },
    presets: {
        chooseOption: 'Choose preset…',
        defaultHint: 'One click sets all settings. You can tweak after.',
        fallbackLoaded: 'Preset loaded. You can tweak after.'
    },
    jobStatus: {
        cancelledFallback: 'Cancelled.',
        errorFallback: 'Error occurred',
        resultLoadFailed: 'Job finished, but failed to load result data.'
    },
    jobProgress: {
        planningPrefix: 'Planning',
        renderingPrefix: 'Rendering'
    },
    jobActions: {
        startFailed: 'Failed to start job.',
        cancelFailed: 'Cancel failed.',
        confirmStop: 'Stop?'
    },
    library: {
        dropzoneDisabledHtml: '<p style="color:#a0aec0;">Select a library above to enable uploading</p>',
        dropzoneSelectedHtml: (libName) => `
        <p>Add to <b>${libName}</b></p>
        <div class=\"btn-group\" style=\"margin-top:10px;\">
            <button onclick=\"document.getElementById('libFiles').click()\" style=\"width:auto; padding:8px 15px; font-size:13px; margin:0;\">+ Add Photos</button>
            <button onclick=\"document.getElementById('libFolders').click()\" style=\"width:auto; padding:8px 15px; font-size:13px; margin:0; background:#718096;\">+ Add Folder</button>
        </div>
    `,
        confirmDelete: 'Delete this library and all its tiles?',
        confirmDeletePublic: 'This is a sample library you can use to create mosaics from. It does not count against your quota. Are you sure you want to delete it?',
        renamePrompt: 'Rename library:',
        deleteConfirm: (name) => `Delete \"${name}\"?`,
        deleteFailed: (message) => `Failed to delete: ${message}`,
        newLibraryLabel: 'New Library',
        privacyToggleTitle: 'Click to change privacy',
        uploadProgress: (current, total) => `Uploading: ${current} / ${total}`,
        tileCountLabel: (count) => `${count} tiles`,
        unknownName: 'Unknown'
    },
    history: {
        deleteConfirm: 'Delete this mosaic? This cannot be undone.',
        deleteFailed: (message) => `Delete failed: ${message}`,
        deleteTitle: 'Delete job'
    },
    trivia: {
        noRepeats: 'No repeats — every tile used a unique photo.',
        missingLibrary: 'Repeated photos detected, but the library could not be resolved for thumbnails.'
    },
    modals: {
        createLibraryPrompt: 'Name your new library (e.g., Summer 2024):',
        createLibraryConfirm: (name) => `Make library "${name}" PUBLIC?\n\nOK = Visible to everyone\nCancel = Private (Only you)`,
        privacyFallbackPrivate: 'Make library PRIVATE?',
        privacyFallbackPublic: 'Make library PUBLIC?',
        privacyDescription: (libraryName) => {
            const safeName = libraryName ? `"${libraryName}"` : 'this library';
            return `Choose whether ${safeName} is private or public.`;
        }
    },
    uploads: {
        imageTooLarge: (actualMp, limitMp) => `Image too large (${actualMp}MP). Limit is ${limitMp}MP.`,
        fileTooLarge: (actualMb, limitMb) => `File too large (${actualMb} MB). Limit is ${limitMb} MB.`,
        uploadSummary: (added, skipped, errors) => {
            let msg = `${added} added.`;
            if (skipped > 0) msg += ` ${skipped} skipped.`;
            if (errors > 0) msg += ` ${errors} errors.`;
            return msg;
        }
    },
    target: {
        previewTitle: 'Click to change the main photo',
        loadedLabel: (filename) => `✅ <b>${filename}</b> loaded (click to change)`,
        dropzonePlaceholder: `
                <div style=\"font-size:36px; margin-bottom:10px;\">📷</div>
                <div><b>Drag & Drop</b> main photo here</div>
                <div style=\"font-size:13px; color:#7f8c8d; margin-top:5px;\">or click to browse</div>
            `
    }
};
